import common from "./common";
export default {
  mixins: [common]
};